module.exports = __webpack_public_path__ + "static/media/heart.3736b6d0.svg";